import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import classnames from 'classnames';

import styles from './Details.module.css';
import ArrowRight from './assets/images/btn-next_dark.svg';
import Typography from '../common/Typography';

import MediaComponent from '../common/MediaComponent';
import ButtonBraun from '../common/ButtonBraun/index';

const DetailsRightPanel = ({ data, room, onClick }) => {
  const nextProduct = room ? data.nextProductInRoom : data.nextProduct;
  const [designerText, setDesignerText] = useState('');
  const [descriptionText, setDescriptionText] = useState(null);
  const [showGradient, setShowGradient] = useState(null);
  const [disabledButton, setDisabledButton] = useState(false);
  const descriptionRef = useRef(null);

  const _isMobile =
    isMobile && typeof window !== 'undefined' && window.innerWidth <= 1024;

  useEffect(() => {
    // To reset scroll
    setDescriptionText(null);
    setTimeout(() => {
      setDescriptionText(data.description);

      // Reset gradient visibility
      if (descriptionRef.current) {
        const el = descriptionRef.current;
        setShowGradient(el.scrollHeight > el.clientHeight);
      }
    }, 100);

    setTimeout(() => {
      setDisabledButton(false);
    }, 1000);

    setDesignerText(
      [...data.text.split(', '), data.year]
        .filter(Boolean)
        .join(_isMobile ? ', ' : '</br>'),
    );
  }, [data, _isMobile]);

  const goToNextItem = () => {
    setDisabledButton(true);
    if (!disabledButton) {
      onClick(nextProduct.type, nextProduct.id);
    }
  };

  return (
    <div className={classnames(styles.rightPanel)}>
      <>
        <Typography
          className={styles.title}
          component="div"
          dangerouslySetInnerHTML={{ __html: data.title }}
        />

        <Typography
          className={styles.text}
          component="div"
          dangerouslySetInnerHTML={{ __html: designerText }}
        />

        <div
          className={classnames(
            styles.descriptionContainer,
            showGradient && styles.descriptionGradient,
          )}
        >
          <div
            ref={descriptionRef}
            className={classnames(styles.description)}
            onScroll={() => setShowGradient(false)}
            component="div"
            dangerouslySetInnerHTML={{ __html: descriptionText }}
          />
        </div>

        <div className={styles.relatedItems}>
          <Typography
            className={styles.relatedText}
            component="div"
            dangerouslySetInnerHTML={{ __html: data.relatedText }}
          />

          <div className={styles.relatedItemsList}>
            {data.related &&
              data.related.map((p, index) =>
                p.image ? (
                  <div
                    key={index}
                    onClick={() => {
                      onClick(p.type, p.id);
                    }}
                  >
                    <MediaComponent
                      image={p.image}
                      srcset={p.image}
                      className={styles.relatedThumb}
                      alt="image"
                      component="img"
                      staticImage
                    />
                  </div>
                ) : (
                  <div key={index} className={styles.notRelated} />
                ),
              )}

            {nextProduct && (
              <div className={styles.nextButton}>
                <ButtonBraun
                  text={nextProduct.text}
                  theme="dark"
                  onClickEvent={() => goToNextItem()}
                >
                  <img alt="arrow" className={styles.arrow} src={ArrowRight} />
                </ButtonBraun>
              </div>
            )}
          </div>
        </div>
      </>
    </div>
  );
};

export default DetailsRightPanel;

DetailsRightPanel.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  room: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  onClick: PropTypes.func,
};
